import gql from 'graphql-tag'
export const SEARCH_USER = gql`query searchUsers($username: String, $numberToShow: Int, $cursor: String, $role: String, $roles: [String], $email: String ){
  users(userProfile_username: $username, first: $numberToShow, after: $cursor, mutableRoles_id: $role, mutableRoles_id_list: $roles, email: $email) {
    edges {
      node {
          id
        userProfile {
          id
          username
          firstName
          lastName
          image {
            id
            contentUrl
          }
        }
      }
    }
    pageInfo {
      endCursor
      startCursor
      hasNextPage
      hasPreviousPage  
    }
  }
}`

export const USER_EXISTS = gql`query UserExists($username: String!) {
  existsUser(username: $username) {
    userProfile {
      username
    }
  }
}`

export const UPDATE_USER = gql`mutation UpdateUser($id: ID!, $email: String!, $mutableRoles: [String]) {
  updateUser(input: { id: $id, email: $email, mutableRoles: $mutableRoles }) {
    user {
      id
      email
      roles
      token
      refreshToken
      isVerified
    }
  }
}`

export const BECOME_CREATOR = gql`mutation BecomeCreator{
  becomeCreatorUser(input: {}) {
    user {
      id
      email
      roles
      creatorEulaAgreedAt
      isVerified
    }
  }
}`

export const VERIFY_EMAIL = gql`mutation VerifyEmail{
  verifyEmailUser(input: {}) {
    user {
      id
      isVerified
    }
  }
}`

export const UPDATE_USER_PROFILE = gql`mutation UpdateUserProfile(
  $id: ID!,
  $username: String,
  $firstName: String,
  $lastName: String,
  $penName: String,
  $creatorNewsletterAgreed: Boolean,

) {
  updateUserProfile(input: { id: $id, username: $username, firstName: $firstName, lastName: $lastName, penName: $penName, creatorNewsletterAgreed: $creatorNewsletterAgreed }) {
    userProfile {
      id
      username
      firstName
      lastName
      penName
      creatorNewsletterAgreedAt
    }
  }
}`
